const NATIVE_LINK_PROTOCOL = /^(?:mailto:|tel:|https?:)/i;
const EXTERNAL_PROTOCOL_HANDOFF = /^(?:mailto:|tel:)/i;
const PROTOCOL_HANDOFF_BYPASS_MS = 2000;

let protocolHandoffBypassUntil = 0;

function prepareProtocolHandoffNavigation() {
  protocolHandoffBypassUntil = Date.now() + PROTOCOL_HANDOFF_BYPASS_MS;
}

/**
 * Consume the one-shot beforeunload exemption created for an external app
 * handoff. The short expiry keeps unrelated page exits protected.
 */
export function consumeProtocolHandoffNavigation() {
  const shouldBypass = protocolHandoffBypassUntil >= Date.now();
  protocolHandoffBypassUntil = 0;
  return shouldBypass;
}

/**
 * Preserve native browser behavior for links that should leave the app's
 * delegated click handling. This listener must be installed before Svelte is
 * mounted so it runs ahead of Svelte's document-level click dispatcher.
 */
export function installLinkDefaultActionGuard(windowRef = globalThis.window) {
  if (typeof windowRef?.addEventListener !== 'function') return () => {};

  const handleClick = (event) => {
    const link = event.target?.closest?.('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const isDownload = link.hasAttribute?.('download') === true;
    if (!isDownload && !NATIVE_LINK_PROTOCOL.test(href)) return;

    if (EXTERNAL_PROTOCOL_HANDOFF.test(href)) {
      prepareProtocolHandoffNavigation();
    }

    // Keep downstream delegated listeners from cancelling the native action.
    // Deliberately do not call preventDefault().
    event.stopImmediatePropagation();
  };

  windowRef.addEventListener('click', handleClick, true);

  return () => {
    windowRef.removeEventListener?.('click', handleClick, true);
  };
}
